/* ============================================
   Kala Curry — Random Products JS
   Fisher-Yates shuffle, XSS-safe rendering,
   loading skeletons, staggered animation
   ============================================ */

(function () {
    'use strict';

    document.querySelectorAll('[data-kc-rp]').forEach(initSection);

    function initSection(section) {
        var grid = section.querySelector('[data-rp-grid]');
        var errorEl = section.querySelector('[data-rp-error]');
        var refreshBtn = section.querySelector('[data-rp-refresh]');
        var collectionHandle = section.dataset.collection || 'random-pool';
        var count = parseInt(section.dataset.count, 10) || 5;
        var showPrice = section.dataset.showPrice === 'true';
        var moneyFormat = section.dataset.moneyFormat || '₹{{amount}}';
        var cache = null;

        function showSkeletons() {
            var html = '';
            for (var i = 0; i < count; i++) {
                html +=
                    '<div class="kc-rp__skeleton">' +
                    '<div class="kc-rp__skeleton-image"></div>' +
                    '<div class="kc-rp__skeleton-text">' +
                    '<div class="kc-rp__skeleton-line"></div>' +
                    '<div class="kc-rp__skeleton-line"></div>' +
                    '</div>' +
                    '</div>';
            }
            grid.innerHTML = html;
        }

        /* Fisher-Yates shuffle — unbiased, O(n) */
        function shuffle(arr) {
            var a = arr.slice();
            for (var i = a.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = a[i];
                a[i] = a[j];
                a[j] = temp;
            }
            return a;
        }

        /* Format money using the store's format string */
        /* Shopify Products JSON API returns prices in currency units (not cents) */
        function formatMoney(price, format) {
            var amount = parseFloat(price).toFixed(2);
            var amountNoDecimals = Math.round(parseFloat(price)).toString();
            var amountWithComma = amount.replace('.', ',');
            return format
                .replace('{{amount_with_comma_separator}}', amountWithComma)
                .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
                .replace('{{amount_no_decimals}}', amountNoDecimals)
                .replace('{{amount}}', amount);
        }

        /* Create a product card element (XSS-safe) */
        function createCard(product) {
            var card = document.createElement('div');
            card.className = 'kc-rp__card';

            var link = document.createElement('a');
            link.href = '/products/' + encodeURIComponent(product.handle);

            /* Image */
            var imageWrap = document.createElement('div');
            imageWrap.className = 'kc-rp__image-wrap';

            if (product.images && product.images.length > 0) {
                var img = document.createElement('img');
                var src = product.images[0].src;
                /* Use Shopify CDN width parameter */
                img.src = src.replace(/\.([^.]+)$/, '_600x.$1');
                img.srcset =
                    src.replace(/\.([^.]+)$/, '_300x.$1') + ' 300w, ' +
                    src.replace(/\.([^.]+)$/, '_600x.$1') + ' 600w, ' +
                    src.replace(/\.([^.]+)$/, '_800x.$1') + ' 800w';
                img.sizes = '(min-width: 66.75em) 280px, (min-width: 48em) 240px, 45vw';
                img.alt = product.title;
                img.loading = 'lazy';
                img.width = 600;
                img.height = 750;
                imageWrap.appendChild(img);
            }

            link.appendChild(imageWrap);

            /* Info */
            var info = document.createElement('div');
            info.className = 'kc-rp__info';

            var title = document.createElement('h3');
            title.className = 'kc-rp__title';
            title.textContent = product.title;
            info.appendChild(title);

            /* Price */
            if (showPrice && product.variants && product.variants.length > 0) {
                var variant = product.variants[0];
                var priceWrap = document.createElement('div');
                priceWrap.className = 'kc-rp__price';

                var priceText = document.createElement('span');
                priceText.textContent = formatMoney(
                    parseInt(variant.price, 10),
                    moneyFormat
                );
                priceWrap.appendChild(priceText);

                /* Compare-at price (if on sale) */
                if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
                    var compareText = document.createElement('span');
                    compareText.className = 'kc-rp__price-compare';
                    compareText.textContent = formatMoney(
                        parseInt(variant.compare_at_price, 10),
                        moneyFormat
                    );
                    priceWrap.appendChild(compareText);
                }

                info.appendChild(priceWrap);
            }

            link.appendChild(info);
            card.appendChild(link);

            return card;
        }

        function render() {
            errorEl.style.display = 'none';
            showSkeletons();

            if (refreshBtn) {
                refreshBtn.classList.add('kc-rp__btn--spinning');
            }

            var fetchAndRender = function (products) {
                var picked = shuffle(products).slice(0, count);

                if (picked.length === 0) {
                    grid.innerHTML = '';
                    errorEl.style.display = '';
                    return;
                }

                grid.innerHTML = '';
                picked.forEach(function (product) {
                    grid.appendChild(createCard(product));
                });

                if (refreshBtn) {
                    refreshBtn.classList.remove('kc-rp__btn--spinning');
                }
            };

            if (cache) {
                /* Use cached data for re-shuffles (instant, no network) */
                setTimeout(function () {
                    fetchAndRender(cache);
                }, 300);
                return;
            }

            fetch('/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250')
                .then(function (res) {
                    if (!res.ok) throw new Error('Collection not found');
                    return res.json();
                })
                .then(function (data) {
                    cache = data.products || [];
                    fetchAndRender(cache);
                })
                .catch(function () {
                    grid.innerHTML = '';
                    errorEl.style.display = '';
                    if (refreshBtn) {
                        refreshBtn.classList.remove('kc-rp__btn--spinning');
                    }
                });
        }

        /* Init */
        render();

        if (refreshBtn) {
            refreshBtn.addEventListener('click', render);
        }
    }
})();
